// components/PrivateRoute.jsx
import { cloneElement, isValidElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";

export default function PrivateRoute({ children }) {
    const { currentUser, userData, activeVenue, venueSelectionRequired, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <div className="h-8 w-8 border-[3px] border-gray-300 border-t-blue-500 rounded-full animate-spin" />
            </div>
        );
    }

    if (currentUser && venueSelectionRequired) {
        return <Navigate to="/select-venue" state={{from: location}} replace />;
    }

    const role = userData?.role;
    const allowed = currentUser && (role === "OWNER" || role === "ADMIN");

    if (!allowed) return <Navigate to="/login" state={{ from: location }} replace />;

    return isValidElement(children)
        ? cloneElement(children, {key: activeVenue?.businessID || role})
        : children;
}
